
export const AppName = {
    Display: "Fraud AML Demo",
    Tracking: "partner-fraud-aml"
}
